import { render, staticRenderFns } from "./invoice-card.vue?vue&type=template&id=06f8e00c&scoped=true&"
import script from "./invoice-card.vue?vue&type=script&lang=js&"
export * from "./invoice-card.vue?vue&type=script&lang=js&"
import style0 from "./invoice-card.vue?vue&type=style&index=0&id=06f8e00c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f8e00c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VFlex,VLayout})
